
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Trash2 } from 'lucide-react';

interface PlaceCollectionManagementProps {
  isCollectionOwner: boolean;
  isOwner: boolean;
  placeName: string;
  onRemove: () => void;
}

export function PlaceCollectionManagement({ 
  isCollectionOwner,
  isOwner,
  placeName,
  onRemove
}: PlaceCollectionManagementProps) {
  if (!isCollectionOwner || isOwner) return null;

  return (
    <AlertDialog>
      <AlertDialog>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Remove place from collection?</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to remove {placeName} from this collection? This action cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={onRemove}
              className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            >
              Remove
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </AlertDialog>
  );
}
